module.exports = __webpack_public_path__ + "static/media/03.286b18de.png";